<template lang="pug">
  #ItemsList
    appHeader
    router-view.content-body
    appFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appFooter from '@/components/partials/AppSaFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'ItemsListComponent',
  components: {
    appHeader,
    appFooter
  }
};
</script>
